<template>
    <div>
        <Hero/>
        <section class="bg-white diagonal diagonal-bottom-only bg-diagonal-g-light-transparent">
            <!-- Start features section -->
            <section id="brn-features">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-6 section-title" v-html="content['home-features'].data.title"></div>
                    </div>
                    <div class="row features-container">
                        <template v-for="(item, index) in content['home-features'].data.items">
                            <div class="feature-item">
                                <div class="icon">
                                    <img v-if="item.icon === null" :src="'/storage/components/home-features/default/icon-' + index + '.svg'" :alt="item.text">
                                    <img v-else :src="'storage/components/'+ content['home-features'].name +'/' + item.icon" :alt="item.text">
                                </div>
                                <p class="h6 text-center" v-html="item.text"></p>
                            </div>
                            <div v-if="index !== content['home-features'].data.items.length-1" class="feature-divider" :class="{ 'reversed' : index === 1 }">
                                <svg width="150" height="40" viewBox="0 0 39.688 10.583" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m0.20659 10.455s6.182-10.214 19.637-10.214c13.455 7e-8 19.637 10.214 19.637 10.214"/>
                                </svg>
                            </div>
                        </template>

                    </div>
                </div>
            </section>
            <!-- End features section -->
            <!-- Start tour section -->
            <section id="brn-tour">
                <BorderDecoration class="bottom-left" primary="var(--color-secondary)" secondary="var(--color-gray-light)"/>
                <div class="container">
                    <div class="content">
                        <h6 class="text-uppercase text-wide-5 text-primary">{{ content['home-bike-tour'].data.subtitle }}</h6>
                        <h2 v-html="content['home-bike-tour'].data.title"></h2>
                        <p v-html="content['home-bike-tour'].data.text"></p>
                        <a :href="content['home-bike-tour'].data.button.url" class="btn btn-primary">{{ content['home-bike-tour'].data.button.content }}</a>
                    </div>
                    <div class="images">
                        <img v-for="image in content['home-bike-tour'].data.images" :src="'/storage/components/home-bike-tour/' + image" :alt="image">
                    </div>
                </div>
            </section>
            <!-- End tour section -->
        </section>

        <!-- Start popular section -->
        <section v-if="tours.length" id="brn-popular-tours" class="diagonal bg-diagonal-white popular">
            <div class="container p-0">
                <div class="row title">
                    <ChalkDecoration class="" :decorated="true">
                        <h2 v-html="content['home-popular-tours'].data.title"></h2>
                    </ChalkDecoration>
                </div>

                <OwlCarousel
                    class="owl-container"
                    :responsive="{
                        0: {
                            items: 1
                        },
                        768: {
                            items: 2
                        },
                        1200: {
                            items: 3
                        }
                    }"
                    :loop="true"
                    :nav="true"
                    :navContainer="'#tour-slider-nav'"
                    :navText="[
                        '<i class=\'bi bi-arrow-left\'></i>',
                        '<i class=\'bi bi-arrow-right\'></i>'
                    ]"
                    :dots="false">
                    <TourSimpleCard
                        v-for="tour in tours"
                        :tour="tour"
                        :key="tour.id"
                        action-button-title="Book Now"
                    :page-slug="getPageSlugByLayout('tour-single')"/>
                </OwlCarousel>
                <div id="tour-slider-nav"></div>
                <div class="text-center mt-4">
                    <a :href="content['home-popular-tours'].data.button.url" class="btn btn-outline-primary">{{ content['home-popular-tours'].data.button.content }} <i class="bi bi-arrow-right ms-2"></i></a>
                </div>
            </div>
        </section>
        <!-- End popular section -->

        <!-- Start rent section -->
        <section id="brn-rent" class="diagonal bg-diagonal-light">
            <BorderDecoration class="top-right" primary="var(--color-secondary)" secondary="var(--color-gray-light)"/>
            <div class="container m-bottom-full">
                <div class="row justify-content-center">
                    <div class="col-lg-6 section-title">
                        <h2 v-html="content['home-rent'].data.title"></h2>
                    </div>
                </div>
                <div class="standing">
                    <div class="standing-background">
                        <svg viewBox="0 0 26.458 26.458" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <linearGradient id="gradient" x1="13.229" x2="13.229" y1="26.977" y2="-.51821" gradientTransform="matrix(.9623 0 0 .9623 .49868 .49868)" gradientUnits="userSpaceOnUse">
                                    <stop style="stop-color:var(--color-secondary);" offset="0"/>
                                    <stop style="stop-color:var(--color-primary);" offset="1"/>
                                </linearGradient>
                            </defs>
                            <ellipse cx="13.229" cy="13.229" rx="11.32" ry="11.32" style="fill:none;stroke-width:3.8192;stroke:url(#gradient);opacity: 0.4;"/>
                        </svg>
                    </div>
                    <div class="standing-foreground">
                        <Magnifier src="/assets/images/illustrations/bike.webp"/>
                        <div class="bike-tooltips">
                            <BikeTooltip id="point-1">
                                <span>You can install here child seat, child trailer or tagalong</span>
                            </BikeTooltip>
                            <BikeTooltip id="point-2">
                                <span>You can install basket on the steering wheel</span>
                            </BikeTooltip>
                            <BikeTooltip id="point-3">
                                <span>All weather bicycle tires</span>
                            </BikeTooltip>
                            <BikeTooltip id="point-4" placement="bottom">
                                <span>Good quality chain</span>
                            </BikeTooltip>
                            <BikeTooltip id="point-5" placement="bottom">
                                <span>Safe tires</span>
                            </BikeTooltip>
                        </div>
                    </div>
                    <div class="arrows">
                        <svg width="155" height="53" viewBox="0 0 155 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.1014 3.28135L12.1015 3.28135C12.2297 3.24841 12.3594 3.27074 12.465 3.33342L12.1014 3.28135ZM12.1014 3.28135L4.29693 5.28736C4.04032 5.35332 3.886 5.61537 3.95214 5.87288L5.96337 13.7038M12.1014 3.28135L5.96337 13.7038M5.11805 5.90505L12.3389 4.21412L12.3389 4.21414L12.3409 4.21361C12.5976 4.14764 12.7519 3.8856 12.6858 3.6281L5.11805 5.90505ZM5.11805 5.90505L6.89276 13.4661C6.95822 13.7232 6.80395 13.9846 6.54767 14.0505L5.11805 5.90505ZM5.96337 13.7038C6.02951 13.9613 6.29102 14.1165 6.54766 14.0505L5.96337 13.7038Z" fill="#CDCDDA" stroke="#CDCDDA" stroke-width="0.2"/>
                            <path d="M154 52C129 52.1667 64.6 42.7 5 5.5" stroke="#CDCDDA"/>
                        </svg>
                        <svg width="154" height="53" viewBox="0 0 154 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M142.64 3.28135L142.64 3.28135C142.512 3.24841 142.382 3.27074 142.277 3.33342L142.64 3.28135ZM142.64 3.28135L150.445 5.28736C150.701 5.35332 150.856 5.61537 150.79 5.87288L148.778 13.7038M142.64 3.28135L148.778 13.7038M148.778 13.7038C148.712 13.9613 148.451 14.1165 148.194 14.0505L148.778 13.7038ZM142.401 4.21361C142.144 4.14764 141.99 3.8856 142.056 3.6281L148.194 14.0505C147.937 13.9845 147.783 13.7225 147.849 13.465C147.849 13.465 147.849 13.465 147.849 13.465L149.621 6.56544L149.277 5.981L142.401 4.21361Z" fill="#CDCDDA" stroke="#CDCDDA" stroke-width="0.2"/>
                            <path d="M0.5 52C25.5 52.1667 90.4 42.7 150 5.5" stroke="#CDCDDA" stroke-width="1.1"/>
                        </svg>
                    </div>
                </div>
                <div class="text-center mt-3">
                    <View360 />
                    <a :href="content['home-rent'].data.button.url" class="btn btn-outline-secondary">{{ content['home-rent'].data.button.content }} <i class="bi bi-arrow-right ms-2"></i></a>
                </div>
            </div>
        </section>
        <!-- End rent section -->

        <!-- Start recommend section -->
        <section id="brn-recommended" class="diagonal bg-diagonal-g-colorful">
            <BorderDecoration class="top-left outside" primary="var(--color-primary)" secondary="var(--color-gray-light)"/>
            <div class="container-fluid">
                <div class="row align-items-center flex-lg-nowrap">
                    <div class="col-lg-4 offset-lg-1 block-info text-white">
                        <h6 class="subtitle">{{ content['home-recommended'].data.subtitle }}</h6>
                        <h2 class="title" v-html="content['home-recommended'].data.title"></h2>
                        <p class="description" v-html="content['home-recommended'].data.text"></p>
                        <div id="recommend-slider-nav"></div>
                    </div>
                    <div class="col-lg-7 block-slider" v-if="products && products.length">
                        <OwlCarousel
                            :responsive="{
                                0: {
                                    items: 1
                                },
                                500: {
                                    items: 2
                                },
                                768: {
                                    items: 3
                                },
                                992: {
                                    items: 2.25
                                }
                            }"
                            :loop="true"
                            :dots="false"
                            :navContainer="'#recommend-slider-nav'"
                            :navText="[
                        '<i class=\'bi bi-arrow-left\'></i>',
                        '<i class=\'bi bi-arrow-right\'></i>'
                        ]">
                            <ProductSimpleCard
                                v-for="(product, index) in products"
                                :key="index"
                                class="m-0"
                                :product="product"
                                :page-slug="getPageSlugByLayout('specifications')" />
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </section>
        <!-- End recommend section -->

        <!-- Start Instagram section -->
        <section v-if="settings.instagramAccountLink" id="brn-instagram-feed" class="diagonal bg-diagonal-g-insta">
            <div class="container">
                <div class="instagram-post-grid">
                    <div v-for="post in instagramPosts" :key="post.id" class="post-item" :style="'transform: rotateZ(' + randAngle() + 'deg)'">
                        <div class="header">
                            <img class="logo" src="/assets/images/logo/logo.svg" alt="">
                            <span class="account-name">bikerent.nyc</span>
                        </div>
                        <a :href="post.permalink">
                            <div class="media" :style="'background-image: url(' + post.mediaUrl + ')'" :alt="post.caption"></div>
                        </a>
                        <p class="caption">{{ post.caption }}</p>
                    </div>
                </div>
                <div class="d-flex justify-content-center mt-5">
                    <a :href="settings.instagramAccountLink" class="btn btn-outline-light" target="_blank">Follow us <i class="bi bi-instagram ms-2"></i></a>
                </div>
            </div>
        </section>
        <!-- End Instagram section -->

        <!-- Start map section -->
        <section id="brn-map" class="diagonal">
            <GoogleMap ref="map" @ready="getLocations" style="display: block; height: 145vh;"/>
            <div class="title-wrapper">
                <h2 class="title" v-html="content['home-places'].data.title"></h2>
            </div>
        </section>
        <!-- End map section -->
    </div>
</template>

<script>
import Hero from "../components/Hero";
import OwlCarousel from "vue-owl-carousel";
import TourSimpleCard from "../components/cards/TourSimpleCard";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import ProductSimpleCard from "../components/cards/ProductSimpleCard";
import BorderDecoration from "../components/elements/BorderDecoration";
import View360 from "../components/elements/View360";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import Magnifier from "../components/elements/Magnifier";
import BikeTooltip from "../components/elements/BikeTooltip";
import GoogleMap from "../components/elements/GoogleMap";
import ApiRequest from "../../utils/api-request";
import {mapGetters} from "vuex";

export default {
    name: "Home",
    components: {
        GoogleMap,
        BikeTooltip,
        Magnifier,
        View360, BorderDecoration, ProductSimpleCard, ChalkDecoration, TourSimpleCard, OwlCarousel, Hero},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    data() {
        return {
            instagramPosts: [],
        }
    },
    computed: {
        ...mapGetters('app', ['tours', 'products']),
    },
    methods: {
        getLocations() {
            new ApiRequest().getLocations().then(
                (response) => {
                    response.data.data.forEach(location => {
                        if (!this.settings.altLocations.includes(location.id)
                            && this.settings.location.id !== location.id) return;

                        location.position = {
                            lat: parseFloat(location.lat),
                            lng: parseFloat(location.lng)
                        };
                        this.$refs.map.addMarker(location)
                    });
                }
            );
        },
        getInstagramFeed() {
            if (!this.settings.instagramAccountLink) return;
            new ApiRequest().getInstagramFeed().then(
                (response) => {
                    this.instagramPosts = response.data;
                }
            );
        },
        randAngle() {
            return (Math.floor(Math.random() * 20) - 10);
        }
    },
    mounted() {
        this.getInstagramFeed();
    }

}
</script>

<style scoped>

</style>
